import Content from '../../content.js';

class GlobalIntegrations extends Content {
  constructor() {
    super({ listeners: {} });
  }

  get dom() {
    return {
      editButton: '.io-form-action-edit',
    };
  }

  get events() {
    let events = [];

    events[`click ${this.dom.editButton}`] =
      '_disableDeprecatedAuthAPIRadioButton';
    return events;
  }

  _disableDeprecatedAuthAPIRadioButton() {
    // input#method0 is the "Auth API (deprecated)" option for Duo Integration.
    // We are disabling it for selection to encourage transition to the WebSDK
    // method of 2FA.
    // When all customers have migrated to Duo Web SDK application protection type
    // we can remove this code.
    var deprecatedAuthAPIRadio = $('td.radio input#method0');

    if (deprecatedAuthAPIRadio.length) {
      deprecatedAuthAPIRadio.prop('disabled', true);
    }
  }
}

module.exports = GlobalIntegrations;
